// «Agrupar por área» and the área sections' collapse state — this browser's own choices (per
// device, like the apps' list options; shared/API.md §37). ON by default. One small external store
// so the Settings toggle and the sidebar agree without a reload; a storage failure (private
// window, blocked site data) just means the defaults.
import { useSyncExternalStore } from 'react';

const GROUP_KEY = 'satori.groupByArea';
const COLLAPSED_KEY = 'satori.areaCollapsed';

export interface AreaPrefs {
  groupByArea: boolean;
  collapsedIds: ReadonlySet<string>;
}

function read(): AreaPrefs {
  let groupByArea = true;
  let collapsed: string[] = [];
  try {
    groupByArea = localStorage.getItem(GROUP_KEY) !== '0';
    const raw = localStorage.getItem(COLLAPSED_KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    if (Array.isArray(parsed)) collapsed = parsed.filter((x): x is string => typeof x === 'string');
  } catch {
    /* defaults */
  }
  return { groupByArea, collapsedIds: new Set(collapsed) };
}

let current: AreaPrefs = read();
const listeners = new Set<() => void>();

function publish(next: AreaPrefs): void {
  current = next;
  for (const l of listeners) l();
}

export function setGroupByArea(on: boolean): void {
  try {
    localStorage.setItem(GROUP_KEY, on ? '1' : '0');
  } catch {
    /* per-viewer convenience */
  }
  publish({ ...current, groupByArea: on });
}

export function setAreaSectionCollapsed(id: string, collapsed: boolean): void {
  const next = new Set(current.collapsedIds);
  if (collapsed) next.add(id);
  else next.delete(id);
  try {
    localStorage.setItem(COLLAPSED_KEY, JSON.stringify([...next]));
  } catch {
    /* per-viewer convenience */
  }
  publish({ ...current, collapsedIds: next });
}

export function useAreaPrefs(): AreaPrefs {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
